"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var config_provider_1 = require("../config-provider");
var unreachableException_1 = tslib_1.__importDefault(require("../util/unreachableException"));
var ButtonGroup = React.forwardRef(function (props, ref) { return (React.createElement(config_provider_1.ConfigConsumer, null, function (_a) {
    var _b;
    var getPrefixCls = _a.getPrefixCls, direction = _a.direction;
    var customizePrefixCls = props.prefixCls, size = props.size, className = props.className, others = tslib_1.__rest(props, ["prefixCls", "size", "className"]);
    var prefixCls = getPrefixCls('btn-group', customizePrefixCls);
    // large => lg
    // small => sm
    var sizeCls = '';
    switch (size) {
        case 'large':
            sizeCls = 'lg';
            break;
        case 'small':
            sizeCls = 'sm';
            break;
        case 'middle':
        case undefined:
            break;
        default:
            // eslint-disable-next-line no-console
            console.warn(new unreachableException_1.default(size));
    }
    var classes = (0, classnames_1.default)(prefixCls, (_b = {},
        _b["".concat(prefixCls, "-").concat(sizeCls)] = sizeCls,
        _b["".concat(prefixCls, "-rtl")] = direction === 'rtl',
        _b), className);
    return React.createElement("div", tslib_1.__assign({}, others, { className: classes, ref: ref }));
})); });
exports.default = ButtonGroup;
//# sourceMappingURL=button-group.js.map